;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Collection = APP.module('Collection'),
		  Model      = APP.module('Model'),
		  FetchCache = APP.module('FetchCache');

	Collection.Players = Collection.FetchCache.extend({
		model:                     Model.Player,
		url:                       'players.json',
		sort_key:                  'stats.avg_points',
		sort_order:                true, //DESC
		player_image_url_prefix:   CONFIG.PLAYERS_URL,
		player_image_url_identity: 'id',
		checksumEmitter: new APP.ChecksumEmitter(),

		players_scores: {},

		comparator: function(a, b) {

			let val_a = this.getValueByKeys(a),
				val_b = this.getValueByKeys(b);

			if (this.sort_order) {
				if (val_a > val_b) {
					return -1;
				} // before
				if (val_b > val_a) {
					return 1;
				} // after
			}
			else {
				if (val_a < val_b) {
					return -1;
				} // before
				if (val_b < val_a) {
					return 1;
				} // after
			}
			if (this.sort_key === 'last_points_val') {
				if (!val_a) {
					return 1;
				}
				if (!val_b) {
					return -1;
				}
			}
			if (this.sort_key === 'last_points') {
				if (!val_a && typeof val_b === 'string') {
					return -1;
				}
				if (!val_b && typeof val_a === 'string') {
					return 1;
				}
				if (typeof val_a === 'string') {
					return 1;
				}
				if (typeof val_b === 'string') {
					return -1;
				}

			}
			return 0;
		},

		setFavouritePlayers: function(favourites) {
			_.each(favourites, _.bind(function(id) {
				let player = this.get(id);
				if(player) {
					player.set('is_favourite', true);
				}
			}, this));

			return this;
		},

		setModelParam: function(name, params) {
			this.each(function(player) {
				player.set(name, params);
			});

			return this;
		},

		setByRounds: function(rounds, actual_round_id) {
			function findByeSquadEntry(squad_id, round) {
				let
					is_in_bye_round     = Boolean(~round.bye_squads.indexOf(squad_id)),
					great_then_round_id = Boolean(actual_round_id && (actual_round_id >= round.id))
				;

				return is_in_bye_round && !great_then_round_id ? round.id : undefined;
			}

			function removeUndefined(value) {
				return value !== undefined;
			}

			this.each(function(player) {
				let findEntry = _.partial(findByeSquadEntry, player.get('squad_id'));

				player.get('stats').by_rounds = rounds.map(findEntry).filter(removeUndefined);
			});

			return this;
		},

		setPointsLastRound: function(round) {
			var squads_obj = {},
				_this = this,
				round_id = round.get('id');

			this.each(function(player) {

				var matches           = round.get('matches'),

					isPlayerPlayed    = function() {
						var matches_len  = matches.length,
							player_match = {},
							squad_id     = player.get('squad_id');

						if(squads_obj[squad_id]) {
							player_match = squads_obj[squad_id];
						}

						if(!player_match.id) {
							while(matches_len--) {
								var match = matches[matches_len];
								if(squad_id == match.away_squad_id || squad_id == match.home_squad_id) {
									squads_obj[squad_id] = match;
									player_match         = match;
									break;
								}
							}
						}

						player.set({ is_player_bye: !player_match.id });

						player.isPlaying(player_match.status && player_match.status != 'complete' && player_match.status != 'scheduled');

						return player_match.status && player_match.status != 'complete';
					},

					is_played         = isPlayerPlayed(),

					points_last_round = is_played ? '-' : 'DNP',
					player_last_round = _this.getValueByKeys(player, 'stats.scores.' + round_id, true),
					last_points_val;

				if (player.get('is_player_bye')) {
					points_last_round = 'BYE';
				}

				else if(player_last_round || player_last_round == 0) {
					points_last_round = +player_last_round;
				}

				_this.players_scores[player.get('id')] = {
					points: player_last_round || 0
				};

				if (_.isNumber(points_last_round)) {
					player.set({
						last_points_val: points_last_round
					});
				}

				player.set({
					is_played:   is_played,
					last_points: points_last_round
				});

			});

			return this;
		},

		resetPointsLastRound: function(round) {
			var squads_obj = {},
				_this = this,
				round_id = round.get('id');

			this.each(function(player) {
				var matches           = round.get('matches'),
					isPlayerPlayed    = function() {
						var matches_len  = matches.length,
							player_match = {},
							squad_id     = player.get('squad_id');

						if(squads_obj[squad_id]) {
							player_match = squads_obj[squad_id];
						}

						if(!player_match.id) {
							while(matches_len--) {
								var match = matches[matches_len];
								if(squad_id == match.away_squad_id || squad_id == match.home_squad_id) {
									squads_obj[squad_id] = match;
									player_match         = match;
									break;
								}
							}
						}

						if (!player_match.id) {
							player.set('is_player_bye', true);
						}

						return player_match.status && player_match.status != 'complete';
					},
					player_id         = player.get('id'),
					score             = _this.players_scores[player_id],

					points_last_round = isPlayerPlayed() ? '-' : 'DNP',
					player_last_round = _this.getValueByKeys(player, 'stats.scores.'+round_id, true);

				if (player.get('is_player_bye')) {
					points_last_round = 'BYE';
				}
				else if(player_last_round || player_last_round == 0) {
					points_last_round = player_last_round;
					if (score) {

						score.diff = player_last_round - score.points;
						score.last_points = player_last_round;

						player.set({
							prev_points: score.diff
						});
					}
				}

				player.set({
					last_points: points_last_round
				});

			});

			return this;
		},

		setOpposition: function(round, is_set_blocked) {
			this.each(function(player) {
				player.getOppositions(round);
				if (is_set_blocked && round.get('status') === 'active') {
					player.setBlocked(round);
				}
			});

			return this;
		},

		setDollarPoints: function(fixed_size) {
			if (!fixed_size) {
				fixed_size = 0;
			}

			this.each(_.bind(function(player, index) {
				var cost   = player.get('cost'),
					points = this.getValueByKeys(player, 'stats.total_points'),
					diff   = +(cost / (points || 1)).toFixed(fixed_size),
					penalties_earned   = this.getValueByKeys(player, 'season_stats.PE') || index,
					penalties_saved   = this.getValueByKeys(player, 'season_stats.PS') || 1;

				const cost_per_million = cost/1000000 || 1;

				player.set('dollar_points', diff);
				player.set('points_per_dollar', points/cost_per_million);
				player.set('coefficient_pe_vs_ps', penalties_earned/penalties_saved);
			}, this));

			return this;
		},

		setSquadName: function (squads) {
			this.each(function (player) {
				let squad_names = squads.findWhere({id: player.get('squad_id')});

				player.set({
					'squad_name':       squad_names.get('name'),
					'squad_short_name': squad_names.get('short_name'),
					'squad_full_name':  squad_names.get('full_name')
				});
			});

			return this;
		},

		setPreDraftState: function(array_id) {
			this.each(function(model) {
				var
					index = array_id.indexOf(model.id),
					is_in_predraft = Boolean(~index)
				;

				model.set({
					is_in_pre_draft_list: is_in_predraft,
					order: is_in_predraft ? index : 0
				});
			});

			return this;
		},

		setPositionNames: function(positions) {
			this.each(function(player) {

				var ids         = player.get('positions'),
					names       = [],
					short_names = [];

				_.each(ids, function(id) {
					var p = positions.get(id);
					names.push(p.get('name'));
					short_names.push(p.get('short_name'));
				});

				player.set({
					'position_names'      : names,
					'position_short_names': short_names
				});
			});

			return this;
		},

		setPositionObjNames: function(positions) {
			this.each(function(player) {
				var ids   = player.get('positions'),
					names = {};

				_.each(ids, function(id) {
					names[id] = positions[id];
				});

				player.set('positions_text', names);
			});

			return this
		},

		setNextMatch: function (squads) {
			this.each(function (player) {
				var squad_id   = player.get('squad_id'),
					next_match = squads.get(squad_id).get('next_match');

				player.set('next_match', {
					home_squad: {
						id:         next_match.home_squad_id,
						short_name: squads.get(next_match.home_squad_id).get('short_name')
					},
					away_squad: {
						id:         next_match.away_squad_id,
						short_name: squads.get(next_match.away_squad_id).get('short_name')
					},
					is_home:    squad_id == next_match.home_squad_id
				});
			});

			return this;
		},

		all: function() {
			this.each(function(player) {
				player.set('is_visible', true);
			});

			return this;
		},

		played: function() {
			this.each(function(player) {
				player.set('is_visible', player.get('status') === 'played');
			});

			return this;
		},

		uncertain: function() {
			this.each(function(player) {
				player.set('is_visible', player.get('status') === 'uncertain');
			});

			return this;
		},

		removeLineupFromPool: function(lineup) {
			var _this = this;

			function removeFromPool(ids) {
				_.each(ids, function(id) {
					if(id != 0) {
						_this.get(id).set('is_visible', false);
					}
				});
			}

			_.each(lineup, function(ids, key) {
				if(_.isArray(ids)) {
					removeFromPool(ids);
				}
				else if(key == 'bench') {
					_.each(lineup.bench, function(ids) {
						removeFromPool(ids);
					});
				}
			});

			return this;
		},

		reorder: function(new_index, original_index) {
			// If nothing is being changed, don't bother
			if(new_index === original_index) {
				return this;
			}

			// Get the model being moved
			var temp = this.at(original_index);

			// Remove it
			this.remove(temp);

			// Add it back in at the new index
			this.add(temp, {at: new_index});

			return this;
		},

		searchByName: function(str) {
			var a = this.slice().reverse();
			_.each(a, _.bind(function(player, key) {
				var full_name = player.get('first_name').trim() + ' ' + player.get('last_name').trim();

				if(!~full_name.toLowerCase().indexOf(str.toLowerCase())) {
					player.set('is_visible', false);
				}
			}, this));


			return this;
		},

		filterByFavourites: function() {
			this.each(function(player) {
				player.set('is_visible', player.get('is_favourite'));
			});

			return this;
		},

		filterByPosition: function(pos) {
			if(_.isArray(pos)) {
				this.each(function(player) {
					if(_.intersection(player.get('positions'), pos).length === 0) {
						player.set('is_visible', false);
					}
				});
			}
			else {
				this.each(function(player) {
					if(player.get('positions').indexOf(pos) === -1) {
						player.set('is_visible', false);
					}
				});
			}

			return this;
		},

		filterBySquad: function(squad_id) {
			if(_.isArray(squad_id)) {
				this.each(function(player) {
					if(squad_id.indexOf(player.get('squad_id')) === -1) {
						player.set('is_visible', false);
					}
				});
			}
			else {
				this.each(function(player) {
					if(player.get('squad_id') !== squad_id) {
						player.set('is_visible', false);
					}
				});
			}

			return this;
		},

		filterByCost: function(cost, remaining_salary) {

			var price = cost.split('-'),
				min   = cost == 'afford' ? false : +price[0] * 1000,
				max   = cost == 'afford' ? false : +price[1] * 1000;

			this.each(function(player) {
				var player_cost = player.get('cost');

				if(max) {
					if(player_cost <= min || player_cost >= max) {
						player.set('is_visible', false);
					}
				}
				else {
					if(player_cost > remaining_salary) {
						player.set('is_visible', false);
					}
				}
			});

			return this;
		},

		filterByCosts: function(costs) {

			var prices = [];

			_.each(costs, function(cost) {
				var price = cost.split('-');

				prices.push({
					min: +price[0] * 1000,
					max: price[1] ? +price[1] * 1000 : false
				})
			});

			this.each(function(player) {
				var player_cost = player.get('cost'),
					is_visible  = false;

				_.each(prices, function(price) {
					if(price.max) {
						if(player_cost >= price.min && player_cost <= price.max) {
							is_visible = true;
						}
					}
					else if(player_cost >= price.min) {
						is_visible = true;
					}
				});

				if(!is_visible) {
					player.set('is_visible', is_visible);
				}
			});

			return this;
		},

		filterByStatus: function(status) {
			if(status === 'all') {
				return this;
			}

			var availables = ['playing', 'uncertain'],
				is_by_available = status === 'available';

			this.each(function(player) {
				var status_index = availables.indexOf(player.get('status'));
				if(is_by_available) {
					player.set('is_visible', status_index !== -1);
				}
				else {
					player.set('is_visible', status_index === -1);
				}
			});

			return this;
		},

		getValueByKeys: function(player, searched_keys, is_silent) {
			var keys = searched_keys ? searched_keys.split('.') : this.sort_key.split('.'),
				value = player.get(keys.shift()),
				val  = value === 0 || value ? value : '';

			_.each(keys, function(key) {
				try {
					val = val[key];
				} catch ( e ) {
					val = null;
				}

			});

			if(typeof val === "string" || val instanceof String) {
				val = val.toLocaleLowerCase();
			}

			if (!is_silent) {
				player.set({sorted_field: val, sorted_key: this.sort_key});
			}
			return val;
		},

		sortByField: function(field, sort_order) {

			if (_.isBoolean(sort_order)) {
				this.sort_order = sort_order;
			}
			else {
				this.sort_order = this.sort_key == field ? !this.sort_order : true;
			}

			this.sort_key = field;
			this.sort();

			return this;
		},

		blockByCost: function(remaining_salary) {
			this.each(function(player) {
				player.set('is_blocked', player.get('cost') > remaining_salary);
			});

			return this;
		},

		filterInPool: function(filter_settings, lineup, remaining_salary) {
			//TODO: use model Luke
			//Clear is_visible
			this.all();

			if(filter_settings.status) {
				this.filterByStatus(filter_settings.status);
			}
			if(filter_settings.is_favourites) {
				this.filterByFavourites();
			}
			if(filter_settings.position) {
				this.filterByPosition(filter_settings.position);
			}
			if(filter_settings.squad) {
				this.filterBySquad(filter_settings.squad);
			}
			if(filter_settings.cost && remaining_salary) {
				this.filterByCost(filter_settings.cost, remaining_salary);
			}

			if(remaining_salary) {
				this.blockByCost(remaining_salary);
			}
			if(filter_settings.search.length > 2) {
				this.searchByName(filter_settings.search);
			}

			this.sortByField(filter_settings.order_by, filter_settings.order);

			this.removeLineupFromPool(lineup);

			return this;
		},

		filterToPool: function() {
			return this.where({
				is_visible: true
			});
		},

		filterMultiply: function(filter_settings) {
			this.all();

			if (filter_settings.status) {
				this.filterByStatus(filter_settings.status);
			}
			if (filter_settings.is_favourites) {
				this.filterByFavourites();
			}
			if (filter_settings.positions.length) {
				this.filterByPosition(filter_settings.positions);
			}
			if (filter_settings.squads.length) {
				this.filterBySquad(filter_settings.squads);
			}
			if (filter_settings.costs && filter_settings.costs.length) {
				this.filterByCosts(filter_settings.costs);
			}
			if (filter_settings.search.length > 2) {
				this.searchByName(filter_settings.search);
			}

			return this;
		},

		getPlayersByRound: function(squads) {
			var moved_players = [];
			this.each(function(player) {
				if(!_.contains(squads, player.get('squad_id'))) {
					moved_players.push(player);
				}
			});
			this.remove(moved_players);

			return this;
		},

		setImageUrl: function() {

			var prefix   = this.player_image_url_prefix,
				identity = this.player_image_url_identity;

			this.each(function(player) {
				player.set('image_url', prefix + player.get(identity));
			});

			return this;
		},

		setImageUrlPrefix: function(value) {

			this.player_image_url_prefix = value;

			return this;
		},

		setImageUrlIdentity: function(value) {

			this.player_image_url_identity = value;

			return this;
		},

		setInLockout: function(is_season_start, is_active_round) {
			if (!is_season_start || !is_active_round) {
				return this;
			}

			this.each(function(player) {
				player.set('is_in_lockout', player.get('locked'));
			});

			return this;
		},

		setPlayed: function(round) {
			if (round.get('status') !== 'active') {
				return this;
			}
			this.each(function(player){
				var match = player.get('match');
				if (match.status !== 'scheduled') {
					player.set('blocked', true);
				}
			});
		},

		setRoundMatchStats: function(stats) {

			this.each(function(player) {

				try {
					player.set('round_match_stats', stats.find({player_id: player.get('id')}).getCalculatedPlayerScores(player))

				} catch(e) {
					player.set('round_match_stats', undefined);
				}

			}, this);

			return this;

		},

		getTopPlayers: function (round_id) {

			var players_by_pos = _.groupBy(this.toJSON(), function (player) {
					return player.positions[0];
				}),
				top_players    = {},
				sort_key       = this.sort_key,
				sort_order     = this.sort_order;

			this.sort_key = 'stats.scores.' + round_id;
			this.sort_order = true;

			_.each(players_by_pos, _.bind(function(line, pos){
				line = line.sort(_.bind(this.topSorter, this));

				top_players[pos] = line.slice(0, 10);
			},this));

			this.sort_key = sort_key;
			this.sort_order = sort_order;

			return top_players;
		},

		sortTopPlayers: function (players, round_id) {
			var sort_key       = this.sort_key,
				sort_order     = this.sort_order;

			this.sort_key = 'stats.scores.' + round_id;
			this.sort_order = true;

			players.sort(_.bind(this.topSorter, this));

			this.sort_key = sort_key;
			this.sort_order = sort_order;

			return players;
		},

		topSorter: function(a, b, sort_key) {
			var additional_sort_key = 'stats.avg_points',
				val_a               = this.getValueByKeysFromObject(a, sort_key),
				val_b               = this.getValueByKeysFromObject(b, sort_key);

			if(val_a > val_b) return -1; // before
			if(val_b > val_a) return 1; // after

			if (!val_a) {
				return 1;
			}

			if (!val_b) {
				return -1;
			}

			if(val_a == val_b) {
				var val_avg_a = this.getValueByKeysFromObject(a, additional_sort_key),
				    val_avg_b = this.getValueByKeysFromObject(b, additional_sort_key);

				if(val_avg_a > val_avg_b) return -1; // before
				if(val_avg_b > val_avg_a) return 1; // after

				if (val_avg_a == val_avg_b) {
					var val_name_a = this.getValueByKeysFromObject(a, 'last_name'),
						val_name_b = this.getValueByKeysFromObject(b, 'last_name');

					if(val_name_a < val_name_b) return -1; // before
					if(val_name_b < val_name_a) return 1; // after
				}
			}

			return 0;
		},

		getValueByKeysFromObject: function(player, searched_keys) {

			var keys = searched_keys ? searched_keys.split('.') : this.sort_key.split('.'),
				val  = player[keys.shift()];

			_.each(keys, function(key) {
				val = val[key];
			});

			return val;
		},

		setPositionsObject(positions) {
			this.each(function(player) {
				let positions_obj = {};

				_.each(player.get('positions'), position_id => positions_obj[position_id] = positions[position_id]);

				player.set({positions_obj});
			});
			return this;
		},

		removeIfTransferred() {
			this.each(player => player.removeIfTransferred());

			return this;
		},

	});

}(window, APP, Backbone, Marionette, $, _));